//1.Import

import Layout from '../Layout';
import PageHeader from "../sections/PageHeader";
import Swiper from 'swiper/bundle';
import "@lottiefiles/lottie-player";


//2.Initialization
const layout=new Layout();
const pageHeader=new PageHeader();


//3.Events
window.addEventListener('DOMContentLoaded', function() {
    pageHeader.init();
    orderMade();
});
//4. Functions

function orderMade(){
    let orderMadeSwiper = new Swiper(".order-made__swiper", {
        slidesPerView: 1,
        spaceBetween: 12,
        allowTouchMove: false,
        preventInteractionOnTransition: true,
        loop:true,
        freeMode: {
            enabled: true,
        },
        autoplay: {
            delay: 0,
        },
        speed: 5000,
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 20,
                loop:true,
                freeMode: {
                    enabled: true,
                },
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
                loop:true,
                freeMode: {
                    enabled: true,
                },
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 24,
                autoHeight:false,
                loop:true,
                freeMode: {
                    enabled: true,
                },
            },
        },
    });
    //return orderMadeSwiper;
}
